<template>
  <ls-table-layout>
    <template #search>
      <master-control-plan-search @search="onSearch"/>
    </template>
    <template #btn>
      <ls-status-button>
        <a-button v-hasPermi="['masterControlPlan:submit']" @click="onSubmit" type="primary" :loading="submitLoading">提交</a-button>
        <a-button v-hasPermi="['masterControlPlan:export']" @click="onExport">导出</a-button>
        <a-button v-hasPermi="['masterControlPlan:async']" @click="onSyncData">同步</a-button>
      </ls-status-button>

    </template>
    <template #table>
      <ls-api-table
        ref="dataTable"
        class="ls-table-footer-summary"
        :columns="columns"
        :tableProps="tableProps"
        :scroll="{ x:1000, fixScreen: true, extraHeight: 80}"
        :selected-rows.sync="selectedRows"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MASTER_CONTROL_PLAN_LIST, // 表格方案配置唯一值
              }"
      >
        <template #earlyMorningDeliveryIs="{text}">
          {{ ['晚班', '早班'][text] }}
        </template>
        <!--        分仓调度-->
        <template #planType="{text,record}">
          <span class="cursor-pointer" @click="onJumpRouter(record)">{{ record.planTypeName }}</span>
        </template>
        <template #satisfyRate="{text}">
          {{ text ? `${text}%` : text }}
        </template>
        <!--体积-->
        <template #volumeSum="{text}">
          {{ formatNum(text,0) }}
        </template>
        <!--金额-->
        <template #amount="{text}">
          {{ formatNum(text,0) }}
        </template>
        <template slot="footer">
          <a-table
            bordered
            :showHeader="false"
            class="footerTable"
            :columns="summaryColumns"
            :data-source="sumInfoList"
            :pagination="false"
          >
            <template #index>
              <span>合计</span>
            </template>
            <template v-for="(item,index) in ['locationQuantitySum', 'canStorageLocation', 'volumeSum', 'amount']" #[item]="text">
              <span :key="item+'_'+index">{{ formatNum(text,0) }}</span>
            </template>
          </a-table>
        </template>
      </ls-api-table>
      <DownloadModal :api-fun="apiExportControlPlanReportList" ref="download" ></DownloadModal>
    </template>
  </ls-table-layout>
</template>
<script>
// import UnsatisfactoryListSearchForm from '@/views/mes/scheduling-plan/unsatisfactory-receiving/components/unsatisfactory-list-search-form.vue'
import {
  apiControlPlanReportList, apiControlPlanReportListSum,
  apiExportControlPlanReportList,
  apiPlanSubmit, apiSynReceiptPlanFromScm
} from '@/api/mes/scheduling-plan/master-control-plan'
import { generateLsTableResData } from '@/utils/util'
import DownloadModal from "@/views/components/download-modal/download-modal";
import MasterControlPlanSearch
  from '@/views/mes/scheduling-plan/master-control-plan/components/master-control-plan-search.vue'
import moment from 'moment/moment'
export default {
  // 不满足收货报表
  // eslint-disable-next-line
  name: 'Master-control-plan-list', // name要和rms配置菜单路由保存一致(首字母大写)

  components: { MasterControlPlanSearch, DownloadModal },
  data() {
    return {
      selectedRows: [],
      submitLoading: false,
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'planListIndex',
          customRender: (text, record, index) => {
            return index + 1;
          }
        },
        {
          title: '入库仓',
          dataIndex: 'warehouseName',
          width: 110,
          scopedSlots: { customRender: 'warehouseName' }
        },
        {
          title: '调度分类',
          dataIndex: 'planType',
          width: 120,
          scopedSlots: { customRender: 'planType' }
        },
        {
          title: '区域',
          dataIndex: 'depositAreaName',
          width: 120,
          scopedSlots: { customRender: 'depositAreaName' }
        },
        {
          title: '标准订单满足率',
          dataIndex: 'satisfyRate',
          width: 150,
          scopedSlots: { customRender: 'satisfyRate' }
        },
        {
          title: '要求到仓日期',
          dataIndex: 'requireDeliveryDay',
          width: 150,
          scopedSlots: { customRender: 'requireDeliveryDay' }
        },
        {
          title: '计划到仓数量',
          dataIndex: 'originalRequireDeliveryQuantity',
          width: 150,
          scopedSlots: { customRender: 'originalRequireDeliveryQuantity' }
        },

        //
        {
          title: '使用库位数',
          dataIndex: 'locationQuantitySum',
          width: 100,
          scopedSlots: { customRender: 'locationQuantitySum' }
        },
        {
          title: '早晚班标识',
          dataIndex: 'earlyMorningDeliveryIs',
          width: 100,
          scopedSlots: { customRender: 'earlyMorningDeliveryIs' }
        },
        {
          title: '总在途预占库位数量',
          dataIndex: 'inTransitLocationSum',
          width: 180,
          scopedSlots: { customRender: 'inTransitLocationSum' }
        },
        {
          title: '剩余库位数',
          dataIndex: 'canStorageLocation',
          width: 100,
          scopedSlots: { customRender: 'canStorageLocation' }
        },
        {
          title: '体积',
          dataIndex: 'volumeSum',
          width: 100,
          scopedSlots: { customRender: 'volumeSum' }
        },
        {
          title: '金额',
          dataIndex: 'amount',
          width: 100,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '推送状态',
          dataIndex: 'statusName',
          width: 100,
          scopedSlots: { customRender: 'statusName' }
        }
      ],
      tableProps: {
        requestApi: generateLsTableResData(apiControlPlanReportList, false),
        pageCurrent: true
      },
      tablePagination: {
        pageNum: 1, // 当前页数
        pageSize: 20
      },
      sumInfoList: [{}]
    }
  },
  computed: {
    summaryColumns () {
      const columns = [
        {
          title: '选择',
          width: 60,
          dataIndex: 'select'
        },
        ...this.columns
      ]
      columns.splice(1, 1, {
        title: '序号',
        width: 70,
        dataIndex: 'index'
      })
      return columns
    }
  },
  methods: {
    onSuccess() {
      const data = this.$refs.dataTable.searchParams
      this.onSearch(data)
    },
    // 搜索
    onSearch (val = {}) {
      this.$refs.dataTable.searchParams = val
      this.summaryMethods(val)
      this.$refs.dataTable.getData()
    },
    apiExportControlPlanReportList,
    // 导出
    onExport () {
      const val = this.$refs.dataTable.searchParams || {}
      this.$refs.download.openModal(val)
    },
    // 合并表格设置同步滚动
    setScroll () {
      // 同步表与footer滚动
      const dom = this.$refs.dataTable.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$refs.dataTable.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      }, true)
    },
    //
    summaryMethods(params) {
      apiControlPlanReportListSum(params).then(res => {
        this.sumInfoList = res.data ? [res.data] : [{}]
      })
    },
    // 同步数据
    onSyncData() {
      apiSynReceiptPlanFromScm().then(res => {
        this.$message.success('同步成功！')
      })
    },
    // 提交
    onSubmit() {
      if (this.selectedRows.length <= 0) {
        return this.$message.error('请选择最少一行进行提交')
      }
      this.submitLoading = true
      const list = []
      this.selectedRows.forEach(e => {
        const { billNoStatus, billNos, ids, planType } = e
        list.push({
          billNoStatus,
          billNos,
          ids,
          planType
        })
      })
      apiPlanSubmit(list).then(res => {
        this.$message.success('提交成功')
        this.onSuccess()
      }).finally(() => {
        this.submitLoading = false
      })
    },
    // 格式化金额
    formatNum (val, exponent) {
      if (!val) {
        return val
      }
      const result = Math.pow(10, exponent)
      let value = Math.floor(Number(val) * result) / result
      value = String(value)
      const reg = value?.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      value = value.replace(reg, '$1,')
      return value
    },
    onJumpRouter (record) {
      // 1: '分仓计划', 2: '调拨计划-基地仓', 3: '外部计划', 4: '调拨计划-卫星仓'
      console.log(record.planType)
      switch (record.planType) {
        case "1":
          this.$router.push({
            name: 'Sub-warehouse-plan',
            query: {
              areaNameList: record.depositAreaCode,
              deliveryDate: record.requireDeliveryDay,
              warehouseCode: record.warehouseCode
            }
          })
          break;
        case "2":
        case "4":
          this.$router.push({
            name: 'Allocation-plan',
            query: {
              areaNameList: record.depositAreaCode,
              deliveryDate: record.requireDeliveryDay,
              warehouseCode: record.warehouseCode,
              planType: record.planType
            }
          })
          break;
        case "3":
          this.$router.push({
            name: 'Receiving-plan',
            query: {
              billNo: record.billNos
            }
          })
          this.$EventBus.$emit('receiving-plan-search')
          break;
      }
    }
  },
  mounted () {
    const value = [moment().startOf('day').add('1', 'days'), moment().endOf('day').add('1', 'days')]
    this.onSearch({
      requireDeliveryTimeStart: value[0].format('YYYY-MM-DD 00:00:00'),
      requireDeliveryTimeEnd: value[1].format('YYYY-MM-DD 23:59:59')
    })
    this.setScroll()
  },
  activated() {
    const value = [moment().startOf('day').add('1', 'days'), moment().endOf('day').add('1', 'days')]
    this.onSearch({
      requireDeliveryTimeStart: value[0].format('YYYY-MM-DD 00:00:00'),
      requireDeliveryTimeEnd: value[1].format('YYYY-MM-DD 23:59:59')
    })
  }
}
</script>
<style lang="less" scoped>
.ls-table-footer-summary{
  /deep/ .ant-table-footer {
    padding: 0;
    border: 0;
  }
}
::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
  padding: 4px;
}
.footerTable {
  ::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
    padding: 4px;
  }
  ::v-deep .ant-table-body{
    overflow-x: hidden !important;
    margin: 0px !important;
    overflow-y: scroll;
  }
}
.cursor-pointer{
  cursor: pointer;
  color: #1890ff;
}
</style>
